import { ChangeEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { isNumeric } from "../../components/PageHeader/actions/functions";
import { INPUT_LENGTH, INPUT_VALUES_LENGTH } from "..";

const useImeiValidation = (imei: string) => {
  const { t } = useTranslation();
  const [imeiError, setImeiError] = useState<string | null>(null);

  const isCorrectLength = (imeiValueLength: number) =>
    imeiValueLength === INPUT_VALUES_LENGTH.Imei;

  const imeiIsValid = isNumeric(imei) && isCorrectLength(imei.length);

  const isValidOptionalImei = imei ? imeiIsValid : true;

  const validateImei = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (inputValue.length === 0) {
      return clearImeiError();
    }

    if (
      (inputValue && !imeiIsValid) ||
      (inputValue.length > INPUT_VALUES_LENGTH.Imei &&
        !isCorrectLength(inputValue.length))
    ) {
      setImeiError(
        t("Dialog##imei not valid", {
          maxNumber: INPUT_LENGTH.Imei
        })
      );
    }
  };

  const clearImeiError = () => setImeiError(null);

  return {
    imeiIsValid,
    isValidOptionalImei,
    imeiError,
    setImeiError,
    clearImeiError,
    validateImei
  };
};

export default useImeiValidation;
